import React from 'react'
import { ClientPlanSettingsContainer } from '@/components/containers/client-plan-settings'

export const ClientPlanSettingsPage: React.FC = () => {
  return <ClientPlanSettingsContainer />
}
